/** English fallback for the WhatsApp integration; wired up in lib/i18n/en.ts. */
export const whatsAppFr = {
  qr: {
    contactMismatch: 'Le numéro de téléphone n’appartient pas au client ou au contact sélectionné.',
    history: 'Message WhatsApp',
    accessDenied:
      'La connexion WhatsApp n’est pas activée sur ce serveur ou vous n’avez pas les droits nécessaires.',
    sendFailed:
      'L’envoi du message n’a pas pu être confirmé. Vérifiez son état et la connexion avant de renvoyer.',
    documentCustomerMismatch: 'Le document n’appartient pas au client de cette conversation.',
    templatesUnavailable: 'Les modèles Cloud ne sont pas disponibles pour WhatsApp (Baileys).',
    provider: 'WhatsApp (Baileys)',
    providerField: 'Fournisseur de connexion',
    cloudProvider: 'WhatsApp Business Cloud API',
    label: 'Connexion non officielle via Baileys',
    help: 'Aide WhatsApp',
    setup:
      'Associez votre compte WhatsApp par QR. Les textes destinés aux contacts ERP connus apparaissent même si la conversation commence sur le téléphone ; les réponses et messages reçus pendant une interruption sont également importés.',
    loadError: 'L’état de connexion n’a pas pu être chargé.',
    connect: 'Connecter le numéro',
    reconnect: 'Rétablir la connexion',
    logout: 'Déconnecter',
    qrAlt: 'Code QR pour associer WhatsApp',
    scan: 'Sur votre téléphone, ouvrez WhatsApp → Appareils connectés → Connecter un appareil et scannez ce code QR.',
    expires: 'Code QR valable jusqu’au {{time}}.',
    expired: 'Le code QR a expiré. Rétablissez la connexion pour obtenir un nouveau code.',
    connectionError:
      'La connexion a été interrompue ou n’a pas pu être établie. Rétablissez-la pour réessayer.',
    actionError: 'L’action a échoué. Vérifiez votre autorisation sur le serveur et réessayez.',
    limits:
      'Les envois individuels nécessitent une action explicite de l’utilisateur. L’historique privé et le carnet d’adresses ne sont pas importés. Le mode de démarrage, les consentements et les restrictions de contact restent applicables.',
    logoutTitle: 'Déconnecter le numéro WhatsApp ?',
    logoutDescription:
      '{{phone}} sera déconnecté et la session enregistrée sera supprimée. Une nouvelle connexion nécessite de scanner à nouveau le code QR.',
    logoutConfirm: 'Déconnecter le numéro et supprimer la session',
    pdfHint:
      'Le document est envoyé directement en PDF via WhatsApp (Baileys). Les modèles Cloud et la fenêtre de 24 heures ne s’appliquent pas ici.',
    pdfSend: 'Envoyer le PDF via WhatsApp',
    accepted: 'L’envoi a été accepté. L’état de livraison suit les événements WhatsApp réels.',
    status: {
      DISCONNECTED: 'Déconnecté',
      CONNECTING: 'Connexion en cours',
      QR_READY: 'Code QR prêt à scanner',
      CONNECTED: 'Connecté',
      EXPIRED: 'Code QR expiré',
      ERROR: 'Erreur de connexion',
    },
  },
  inbox: {
    title: "Boîte de réception de l'équipe WhatsApp",
    subtitle: 'Messages clients et documents PDF via la connexion WhatsApp disponible.',
    search: 'Rechercher un nom, un numéro ou un message',
    empty: 'Aucune conversation dans cette vue.',
    error: "Les conversations n'ont pas pu être chargées.",
    selectHint: 'Sélectionnez une conversation sur la gauche.',
  },
  scope: {
    ALL: 'Tous',
    MINE: 'Les miennes',
    UNASSIGNED: 'Non attribué',
    CLOSED: 'Fermé',
  },
  conversationStatus: {
    OPEN: 'Ouverte',
    PENDING: 'En attente',
    RESOLVED: 'Résolu',
    ARCHIVED: 'Archivé',
  },
  status: {
    PENDING: 'En attente d’envoi',
    SENT: 'Envoyé',
    DELIVERED: 'Livré',
    READ: 'Lu',
    FAILED: 'Échec',
  },
  templateStatus: {
    APPROVED: 'Approuvé',
    PENDING: 'En revue',
    REJECTED: 'Rejeté',
    PAUSED: 'En pause',
    DISABLED: 'Désactivé',
  },
  category: {
    MARKETING: 'Commercialisation',
    UTILITY: 'Utilitaire',
    AUTHENTICATION: 'Authentification',
  },
  optIn: {
    OPTED_IN: 'Consentement au dossier',
    OPTED_OUT: 'Objection enregistrée',
    PENDING: 'Demande en attente',
    NOT_REQUESTED: 'Pas encore demandé',
  },
  window: {
    open: 'Fenêtre ouverte · {{hours}} h {{minutes}} min',
    openShort: 'Fenêtre ouverte ({{hours}} h {{minutes}} min)',
    closed: 'Modèles uniquement',
    closedShort: 'Fenêtre fermée — modèles uniquement',
  },
  chat: {
    unknownCustomer: 'Aucun client lié',
    openCustomer: 'Profil client',
    assignee: 'Cessionnaire',
    unassigned: 'Non attribué',
    status: 'Statut',
    empty: "Aucun message pour l'instant dans cette conversation.",
    error: "L'historique des messages n'a pas pu être chargé.",
    placeholder: 'Écrire un message… (Entrez les envois, Maj+Entrée pour une nouvelle ligne)',
    send: 'Envoyer',
    emoji: 'Insérer un emoji',
    attachDocument: 'Joindre le document',
    useTemplate: 'Utiliser le modèle',
    download: 'Télécharger',
    attachment: 'Pièce jointe',
    templateLabel: 'Modèle : {{name}}',
    windowClosed:
      'La fenêtre de 24 heures a expiré. Envoyez un modèle pour rouvrir la conversation.',
    chooseTemplate: 'Choisir un modèle',
  },
  sidebar: {
    title: 'Dossier client',
    placeholder: 'Sélectionnez une conversation pour voir les détails du client.',
    noCustomer: "Ce numéro n'est lié à aucun client.",
    contact: 'Contact : {{name}}',
    optIn: 'Opt-in WhatsApp confirmé',
    optInSaved: 'Consentement enregistré.',
    openDocuments: 'Documents ouverts',
    noDocuments: 'Aucun document ouvert.',
    documentsError: "Les documents n'ont pas pu être chargés.",
  },
  templates: {
    pickTitle: 'Envoyer le modèle',
    pickDescription:
      'Seuls les modèles approuvés par Meta peuvent être livrés en dehors de la fenêtre de 24 heures.',
    template: 'Modèle',
    choose: 'Choisir un modèle',
    placeholder: 'Espace réservé {{position}}',
    preview: 'Aperçu',
    pdfHeader: 'Document PDF comme en-tête',
    send: 'Envoyer le modèle',
    sent: 'Le modèle a été envoyé.',
    error: "Les modèles n'ont pas pu être chargés.",
    emptyApproved: "Aucun modèle approuvé n'est disponible.",
  },
  document: {
    title: 'Joindre le document',
    description: 'Le document est envoyé au format PDF à la conversation en cours.',
    document: 'Document',
    choose: 'Choisir un document',
    caption: 'Légende',
    captionPlaceholder: 'Texte facultatif pour la pièce jointe',
    send: 'Envoyer le document',
    sent: 'Le document a été envoyé.',
    empty: "Il n'existe aucun document pour ce client.",
    error: "Les documents n'ont pas pu être chargés.",
  },
  documentSend: {
    chooseConversation: 'Choisir une conversation',
    action: 'Envoyer via WhatsApp',
    title: 'Envoyer le document via WhatsApp',
    description: 'Remettre le document {{number}} à {{customer}}.',
    noConversation: "Il n'y a pas encore de conversation pour ce client.",
    createChat: 'Créer une conversation',
    windowOpenHint: 'La fenêtre de service est ouverte ; le modèle livre le document avec son PDF.',
    windowClosedHint: 'La fenêtre de service est fermée. La livraison utilise un modèle approuvé.',
    chooseTemplate: 'Choisir un modèle et envoyer',
  },
  customerTab: {
    subtitle:
      'Conversations WhatsApp enregistrées pour ce client. Seuls les comptes qui vous sont affectés sont affichés.',
    start: 'Nouvelle conversation',
    startTitle: 'Démarrer une conversation WhatsApp',
    startDescription: 'Le numéro est automatiquement normalisé à E.164.',
    started: 'La conversation a été créée.',
    phone: 'Numéro de portable',
    empty: "Il n'y a pas encore de conversation WhatsApp pour ce client.",
    error: "Les conversations n'ont pas pu être chargées.",
    noAccess: "Vous n'avez pas l'autorisation d'afficher l'historique de WhatsApp.",
  },
  config: {
    title: 'Configuration WhatsApp',
    subtitle: 'Gérer les connexions WhatsApp et les modèles Cloud.',
    error: "La configuration n'a pas pu être chargée.",
    tabConnection: 'WhatsApp Business Cloud API',
    tabTemplates: 'Modèles Cloud',
    credentials: 'API méta-graphique',
    credentialsHint:
      'Ces valeurs proviennent du tableau de bord du développeur Meta. Les secrets sont stockés cryptés et ne sont jamais restitués.',
    phoneNumberId: 'Numéro de téléphone ID',
    wabaId: 'ID de compte professionnel WhatsApp',
    appId: "Identifiant de l'application",
    businessPhoneNumber: "Numéro de l'expéditeur (E.164)",
    displayName: "Nom d'affichage\nClé",
    accessToken: "Jeton d'accès permanent",
    appSecret: "Secret de l'application",
    secretPlaceholder: 'Remplir uniquement pour remplacer la valeur',
    secretSet: 'Stocké ({{hint}})',
    secretMissing: 'Pas encore stocké',
    rotateToken: 'Générer un nouveau jeton de vérification',
    rotateTokenHint: 'Nécessite de reconfigurer le webhook dans le tableau de bord Meta.',
    saved: 'La configuration a été enregistrée.',
    test: 'Tester la connexion',
    verifiedName: 'Nom vérifié',
    displayNumber: 'Afficher le numéro',
    quality: 'Qualité',
    limit: 'Limite de messagerie',
    checkedAt: 'Vérifié à {{timestamp}}',
    webhook: 'Configuration du webhook',
    webhookHint:
      'Saisissez ces valeurs sous "Webhooks" dans le tableau de bord du développeur Meta et abonnez-vous au champ "messages".',
    callbackUrl: 'URL de rappel',
    verifyToken: 'Vérifier le jeton',
    copy: 'Copier',
    copied: 'Copié dans le presse-papiers.',
    lastWebhook: 'Dernière livraison : {{timestamp}}',
    noWebhookYet: "Aucune livraison reçue pour l'instant.",
    templates: 'Modèles de Meta',
    templatesHint: 'Le miroir local est entièrement actualisé à chaque synchronisation.',
    templatesEmpty: "Aucun modèle n'a encore été synchronisé.",
    sync: 'Modèles de synchronisation',
    syncDone: 'Modèles {{fetched}} récupérés · {{created}} nouveau · {{updated}} mis à jour.',
    templateName: 'Nom',
    language: 'Langue',
    category: 'Catégorie',
    status: 'Statut',
    templatePreview: 'Aperçu avec des espaces réservés ERP',
  },
  accounts: {
    unavailableMember: 'Employé qui n’est plus disponible ({{id}})',
    unavailableHelp:
      'Ces affectations enregistrées concernent des employés qui ne sont plus disponibles. Supprimez-les explicitement si elles doivent être révoquées. Aucune affectation n’est supprimée automatiquement.',

    title: 'Comptes WhatsApp',
    description:
      'Chaque compte dispose de sa propre connexion. Seuls les employés affectés peuvent voir ses conversations et son code QR.',
    select: 'Compte WhatsApp',
    choose: 'Choisir un compte',
    all: 'Tous les comptes affectés',
    empty: 'Aucun compte WhatsApp ne vous est affecté.',
    error: 'Les comptes WhatsApp n’ont pas pu être chargés.',
    new: 'Ajouter un compte',
    edit: 'Modifier le compte',
    label: 'Nom du compte',
    members: 'Employés affectés',
    noMembers: 'Sans employés affectés, personne ne peut utiliser ce compte.',
    manageEmpty: 'Aucun compte WhatsApp n’a encore été ajouté.',
    saved: 'Le compte WhatsApp a été enregistré.',
    saveError: 'Le compte n’a pas pu être enregistré. Vérifiez les données et réessayez.',
    rescan: 'L’association a été perdue. Scannez un nouveau code QR.',
    membersError: 'Les employés n’ont pas pu être chargés.',
    invalid: 'Vérifiez le nom du compte et la sélection des employés.',
  },
  history: {
    connect: 'Connecter et charger l’historique',
    connectTitle: 'Associer {{account}} avec l’historique texte ?',
    connectDescription:
      'Choisissez cette action avant le premier scan QR pour demander l’historique texte disponible pendant l’association. Une connexion existante n’est pas déconnectée automatiquement.',
    connectConfirm: 'Associer avec l’historique texte',
    pairingRequired:
      'Cette connexion ne dispose d’aucun message ERP adapté comme point de départ. Déconnectez volontairement le compte, puis choisissez « Connecter et charger l’historique » avant de scanner le nouveau code QR. Une reconnexion normale ne récupère pas cet historique.',

    action: 'Demander l’historique',
    title: 'Demander l’historique pour {{account}} ?',
    description:
      'Demande les textes disponibles de l’appareil associé. Seuls les clients et interlocuteurs ERP connus ou les conversations explicitement affectées à ce compte sont importés. Les anciens messages sont chargés par lots : au maximum 200 conversations, 1 000 messages par conversation et dix minutes par demande. Renouvelez la demande pour un historique plus long. La disponibilité dépend de WhatsApp ; une importation complète n’est pas garantie.',
    confirm: 'Demander l’historique maintenant',
    pending: 'Demande de l’historique en cours …',
    requested:
      'La demande a été transmise. Les messages texte disponibles des contacts connus de l’ERP apparaîtront après traitement.',
    unavailable: 'L’appareil associé ne fournit pas d’historique actuellement.',
    error: 'L’historique n’a pas pu être demandé. Vérifiez la connexion et réessayez.',
  },
  phone: {
    change: 'Changer le numéro',
    changeTitle: 'Changer le numéro WhatsApp',
    changeDescription:
      'Une conversation distincte est créée pour le nouveau numéro sur le compte WhatsApp choisi. L’historique existant est conservé. Les données du client ne sont pas modifiées automatiquement.',
    useNumber: 'Utiliser le nouveau numéro',

    existing: 'Numéro existant',
    choose: 'Choisir le numéro d’un client ou contact',
    invalid: 'Saisissez un numéro de mobile valide, par exemple 0170 1234567 ou +49 170 1234567.',
    loadError: 'Les numéros de téléphone existants n’ont pas pu être chargés.',
    source: {
      CUSTOMER: 'Numéro du client',
      CONTACT_MOBILE: 'Contact : mobile',
      CONTACT_PHONE: 'Contact : téléphone',
    },
  },
  baileysTemplates: {
    title: 'Modèles WhatsApp locaux',
    description:
      'Textes réutilisables pour les comptes Baileys. Les modèles locaux ne nécessitent aucune approbation Meta et respectent les préférences de contact habituelles.',
    create: 'Ajouter un modèle local',
    edit: 'Modifier le modèle local',
    delete: 'Supprimer le modèle local',
    confirmDeleteTitle: 'Supprimer {{name}} ?',
    confirmDeleteDescription:
      'Ce modèle local ne sera plus disponible pour les nouveaux messages. Les messages existants sont conservés.',
    empty: "Aucun modèle local n'a encore été ajouté.",
    loadError: "Les modèles locaux n'ont pas pu être chargés.",
    name: 'Nom du modèle',
    language: 'Langue',
    body: 'Texte du message',
    bodyHelp:
      'Utilisez des paramètres numérotés comme {{example}}. Commencez à 1 sans sauter de numéro ; au maximum 50 paramètres différents et 4 096 caractères.',
    variableMapping: 'Valeurs ERP facultatives',
    mappingSource: 'Source de valeur {{position}}',
    mappingLabel: 'Libellé du champ {{position}}',
    noMapping: 'Saisir manuellement',
    transactionalOnly:
      'Pour les messages transactionnels. La publicité nécessite le processus marketing distinct avec un consentement documenté.',
    saved: 'Le modèle local a été enregistré.',
    deleted: 'Le modèle local a été supprimé.',
    versionConflict:
      "Ce modèle a été modifié par une autre personne. Rechargez-le avant d'enregistrer ou d'envoyer.",
    duplicateName: 'Un modèle local existe déjà avec ce nom et cette langue.',
    invalidPlaceholders:
      'Utilisez uniquement des paramètres numérotés de 1 à 50 sans interruption, comme {{example}}.',
    invalidMapping:
      'Associez chaque valeur ERP une seule fois et uniquement à un paramètre existant.',
    invalidParameters:
      'Renseignez chaque paramètre une seule fois avec une valeur valide. Vérifiez la longueur du message.',
    invalidName: 'Saisissez un nom de modèle de 120 caractères maximum.',
    invalidLanguage: 'Choisissez une langue prise en charge.',
    invalidBody: 'Saisissez un message de 4 096 caractères maximum.',
    validationSummary: "Le modèle n'a pas pu être enregistré. Vérifiez les champs signalés.",
    discardTitle: 'Abandonner les modifications ?',
    discardDescription: 'Les modifications non enregistrées de ce modèle seront perdues.',
    discard: 'Abandonner les modifications',
    pickTitle: 'Envoyer un modèle WhatsApp local',
    pickDescription:
      "Vérifiez le texte et toutes les valeurs avant l'envoi depuis le compte Baileys sélectionné.",
    choose: 'Choisir un modèle local',
    send: 'Envoyer le message',
    preview: 'Aperçu du message',
    pdfAttachment: 'PDF joint',
    search: 'Rechercher des modèles locaux',
    page: 'Page {{page}} sur {{pages}}',
    captionTooLong: 'Un message accompagnant un PDF peut contenir 1 024 caractères maximum.',
    sources: {
      'customer.name': 'Nom du client',
      'customer.number': 'Numéro du client',
      'contact.firstName': 'Prénom du contact',
      'document.number': 'Numéro du document',
      'document.date': 'Date du document',
      'document.dueDate': "Date d'échéance",
      'document.grossTotal': 'Montant TTC',
      'document.currency': 'Devise',
      'tenant.name': "Nom de l'entreprise",
      'user.name': "Nom de l'employé",
      custom: 'Valeur manuelle',
    },
  },
};
